// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"webinarJoin_spinnerContainer__utEMp"};